import React from 'react'

const ReservationContext = React.createContext();

export default ReservationContext;